import React from 'react'
import "./styles/error.css";

const ErrorPage = () => {
    return (
        <>
            <div className='error_container'>
                <h1>404 Error</h1>
                <h2>Page Not Found</h2>
            </div>
        </>
    )
}

export default ErrorPage